import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  imports: [],
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class LoadingScreenComponent {
  @Input() loadingMessage = 'Loading, please wait...';
}
